import * as Yup from "yup";

export const validationSchema = [
  {
    name: "code",
    placeholder: "Mã firmware",
    validate: Yup.string()
      .required("Hãy nhập Mã firmware")
      .matches(
        /^.{8,100}$/,
        "Mã firmware phải ít nhất 8 ký tự, không vượt quá 100 ký tự"
      ),
  },
  {
    name: "version",
    placeholder: "Ex: 0.0.0",
    validate: Yup.string()
      .required("Vui lòng nhập Version")
      .matches(
        /^.{8,100}$/,
        "Version phải ít nhất 8 ký tự, không vượt quá 100 ký tự"
      ),
  },
  {
    name: "mac",
    placeholder: "Ex: a0:00:f0:00:0c:0b",
    validate: Yup.string()
      .required("Vui lòng nhập Mac")
      .matches(
        /^.{8,100}$/,
        "Mac phải ít nhất 8 ký tự, không vượt quá 255 ký tự"
      ),
  },
  {
    name: "macWifi",
    placeholder: "Ex: 00:e0:00:b0:00:00",
    validate: Yup.string()
      .required("Vui lòng nhập Mac wifi")
      .matches(
        /^.{8,100}$/,
        "Mac phải ít nhất 8 ký tự, không vượt quá 255 ký tự"
      ),
  },
  {
    name: "status",
    placeholder: "Chọn trạng thái",
    validate: Yup.string().required("Vui lòng chọn trạng thái"),
    defaultValue: "NOT_CONNECTED",
  },
  {
    name: "isActive",
    placeholder: "Chọn tình trạng",
    validate: Yup.string().required("Vui lòng chọn tình trạng"),
    defaultValue: false,
  },
  {
    name: "ip",
    placeholder: "Ex: X.X.X.X",
    validate: Yup.string()
      .required("Vui lòng nhập IP")
      .matches(/^.{0,100}$/, "IP phải không vượt quá 500 ký tự"),
  },
];
